export default{
  'datagrid': 'Datagrid',
  'board': 'Board',
  'autoform': 'Autoform',
  'dashboard': 'Dashboard',
  'report': 'Report',
  'survey': 'Enquete',
  'function': 'Função',
  'page': 'Página',
  'mix': 'Mista',
  options: [
    { value: 'datagrid', text: 'Datagrid' },
    { value: 'autoform', text: 'Autoform' },
    { value: 'board', text: 'Board' },
    { value: 'dashboard', text: 'Dashboard' },
    { value: 'report', text: 'Report' },
    { value: 'survey', text: 'Enquete' },
    { value: 'function', text: 'Função' },
    { value: 'page', text: 'Página' },
    { value: 'mix', text: 'Mista' },
  ],
}
